// config *must* run before everything else
/* eslint-disable */
import config from '../config/config';
/* eslint-enable */

import React, { Fragment, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import type { Article, Corporation, WithContext, FAQPage } from 'schema-dts';

import useLayoutQuery from '../hooks/use-layout-query';
import { getCanonical } from '../lib/helpers';
import getMetaTags from '../lib/meta';
import getDrivescoreMetaTags from '../lib/drivescore-meta';
import favicon from '../assets/global/favicon.ico';
import drivescoreFavicon from '../assets/global/drivescore-favicon.ico';

import './index.css';
import './reset.css';

const isDrivescore = process.env.SITE === 'drivescore';

const site = process.env.SITE || 'clearscore';

const siteUrl = {
    clearscore: `https://www.clearscore.com`,
    drivescore: `https://www.drivescore.com`,
};

const faviconLink = {
    rel: 'shortcut icon',
    type: 'image/png',
    href: isDrivescore ? drivescoreFavicon : favicon,
};

const locale = config.DEFAULT_LOCALE;

const CS_LOAD_EVENT = 'cs:website:loaded';

interface Meta {
    title: string;
    description: string;
    image?: string;
    url?: string;
    robots?: string;
}

interface LayoutProps {
    meta: Meta;
    location: string;
    schemaMarkup?: WithContext<Article | Corporation | FAQPage>;
    canonicalUrl?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, meta, schemaMarkup = {}, location = '', canonicalUrl }) => {
    const { common } = useLayoutQuery();
    const metaTags = isDrivescore
        ? getDrivescoreMetaTags(meta)
        : getMetaTags({ market: config.MARKET, locale, ...meta, location });

    const canonicalLink = canonicalUrl || getCanonical({ location, siteUrl: `${siteUrl[site]}` });

    const canonical = {
        rel: 'canonical',
        key: canonicalLink,
        href: canonicalLink,
    };

    const script = [
        schemaMarkup && {
            type: 'application/ld+json',
            innerHTML: JSON.stringify(schemaMarkup),
        },
    ].filter(Boolean);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent(CS_LOAD_EVENT));
        }
    }, []);

    return (
        <Fragment>
            {/* prevent old native app code errors */}
            <div className="navbar" style={{ display: 'none' }} />
            <Helmet title={meta.title} meta={metaTags} link={[faviconLink, canonical]} script={script} />
            {typeof children === 'function' ? children({ commonModules: common, market: config.MARKET }) : children}
        </Fragment>
    );
};

export default Layout;
